import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "vorschlagPerMailDirekt",
  novalidate: ""
}
const _hoisted_2 = ["required", "aria-required"]
const _hoisted_3 = ["required", "aria-required"]
const _hoisted_4 = ["required", "aria-required"]
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  class: "c-form-control-checkbox__label control-label",
  for: "datenschutzhinweiseAkzeptiert"
}
const _hoisted_7 = {
  class: "c-form-control-checkbox__label control-label",
  for: "datenschutzhinweiseAkzeptiert"
}
const _hoisted_8 = {
  class: "c-form-control-checkbox__label control-label",
  for: "werbeeinwilligung"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_titel_zelle = _resolveComponent("titel-zelle")!
  const _component_Anrede = _resolveComponent("Anrede")!
  const _component_zelle = _resolveComponent("zelle")!
  const _component_Zeile = _resolveComponent("Zeile")!
  const _component_validierungs_fehler = _resolveComponent("validierungs-fehler")!
  const _component_Zelle = _resolveComponent("Zelle")!
  const _component_icon_sprite = _resolveComponent("icon-sprite")!
  const _component_Fehlermeldung = _resolveComponent("Fehlermeldung")!
  const _component_EmailBestaetigung = _resolveComponent("EmailBestaetigung")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.showError && !_ctx.showSuccess)
      ? (_openBlock(), _createElementBlock("form", _hoisted_1, [
          _createVNode(_component_Zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "vertikal-zentrieren": false,
                "ausrichtung-responsiv": false
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Anrede")
                ])),
                _: 1,
                __: [10]
              }),
              _createVNode(_component_zelle, {
                breite: 12,
                class: "u-form-grid-nospace-y"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Anrede, {
                    id: "anrede",
                    required: _ctx.isVorschlagEmail,
                    modelValue: _ctx.state.anrede,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.anrede) = $event)),
                    ariaRequired: "true",
                    ariaLabel: "Anrede",
                    tabindex: "0",
                    autofocus: true,
                    style: {"margin":"0 !important"},
                    gemeinschaftsAnrede: false,
                    firmenAnrede: false
                  }, null, 8, ["required", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                breite: 6,
                "vertikal-zentrieren": false,
                "ausrichtung-responsiv": false
              }, {
                default: _withCtx(() => _cache[11] || (_cache[11] = [
                  _createTextVNode("Vorname")
                ])),
                _: 1,
                __: [11]
              }),
              _createVNode(_component_titel_zelle, {
                breite: 6,
                "vertikal-zentrieren": false,
                "ausrichtung-responsiv": false
              }, {
                default: _withCtx(() => _cache[12] || (_cache[12] = [
                  _createTextVNode("Nachname")
                ])),
                _: 1,
                __: [12]
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_zelle, {
                breite: 6,
                class: "u-form-grid-nospace-y"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "vorname",
                    name: "vorname",
                    class: "c-form-control__input",
                    "data-cy": "vorname",
                    placeholder: "Vorname",
                    minlength: "2",
                    maxlength: "40",
                    required: _ctx.isVorschlagEmail,
                    "aria-required": _ctx.isVorschlagEmail,
                    "aria-label": "Vorname",
                    "data-fehlermeldung": "Bitte geben Sie Ihren Vornamen ein (2-40 Zeichen).",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.vorname) = $event))
                  }, null, 8, _hoisted_2), [
                    [
                      _vModelText,
                      _ctx.state.vorname,
                      void 0,
                      {
                        lazy: true,
                        trim: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.vorname
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              }),
              _createVNode(_component_zelle, {
                breite: 6,
                class: "u-form-grid-nospace-y"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "nachname",
                    name: "nachname",
                    class: "c-form-control__input",
                    "data-cy": "nachname",
                    placeholder: "Name",
                    minlength: "2",
                    maxlength: "40",
                    required: _ctx.isVorschlagEmail,
                    "aria-required": _ctx.isVorschlagEmail,
                    "aria-label": "Nachname",
                    "data-parsley-combined-name-length": "40",
                    "data-fehlermeldung": "Bitte geben Sie Ihren Nachnamen ein (2-40 Zeichen).",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.nachname) = $event))
                  }, null, 8, _hoisted_3), [
                    [
                      _vModelText,
                      _ctx.state.nachname,
                      void 0,
                      {
                        lazy: true,
                        trim: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.nachname
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_Zeile, null, {
            default: _withCtx(() => [
              _createVNode(_component_titel_zelle, {
                "vertikal-zentrieren": false,
                "ausrichtung-responsiv": false
              }, {
                default: _withCtx(() => _cache[13] || (_cache[13] = [
                  _createTextVNode("E-Mail-Adresse")
                ])),
                _: 1,
                __: [13]
              }),
              _createVNode(_component_Zelle, {
                breite: 12,
                class: "u-form-grid-nospace-y"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "email",
                    name: "email",
                    class: "c-form-control__input",
                    "data-cy": "email",
                    placeholder: "E-Mail",
                    minlength: "2",
                    maxlength: "60",
                    required: _ctx.isVorschlagEmail,
                    "aria-required": _ctx.isVorschlagEmail,
                    "aria-label": "Email",
                    "data-fehlermeldung": "Bitte geben Sie Ihre E-Mail-Adresse ein (2-60 Zeichen).",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.email) = $event))
                  }, null, 8, _hoisted_4), [
                    [
                      _vModelText,
                      _ctx.state.email,
                      void 0,
                      {
                        lazy: true,
                        trim: true
                      }
                    ]
                  ]),
                  _createVNode(_component_validierungs_fehler, {
                    "fehler-text": _ctx.fehler.email
                  }, null, 8, ["fehler-text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.istOutboundAktiv)
            ? (_openBlock(), _createBlock(_component_Zeile, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_titel_zelle, {
                    "vertikal-zentrieren": false,
                    "ausrichtung-responsiv": false
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("Telefon")
                    ])),
                    _: 1,
                    __: [14]
                  }),
                  _createVNode(_component_Zelle, {
                    breite: 12,
                    class: "u-form-grid-nospace-y"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "telefon",
                        name: "telefon",
                        class: "c-form-control__input",
                        "data-cy": "telefon",
                        placeholder: "Telefon",
                        minlength: "6",
                        maxlength: "30",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.telefon) = $event)),
                        "aria-label": "Telefon"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.state.telefon,
                          void 0,
                          {
                            lazy: true,
                            trim: true
                          }
                        ]
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.telefon
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isVorschlagEmail)
            ? (_openBlock(), _createBlock(_component_Zeile, {
                key: 1,
                class: "c-form-control-checkbox form-group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Zelle, { breite: 12 }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "datenschutzhinweiseAkzeptiert",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.datenschutzhinweiseAkzeptiert) = $event)),
                        value: _ctx.isVorschlagEmail,
                        class: "c-form-control-checkbox__input c-form-control-checkbox__input--spring",
                        "data-fehlermeldung": "Bitte akzeptieren Sie die Datenschutzhinweise.",
                        required: true,
                        "aria-required": true,
                        "aria-label": "Ja, die Datenschutzhinweise habe ich zur Kenntnis genommen",
                        name: "datenschutzhinweiseAkzeptiert",
                        type: "checkbox"
                      }, null, 8, _hoisted_5), [
                        [_vModelCheckbox, _ctx.state.datenschutzhinweiseAkzeptiert]
                      ]),
                      _createElementVNode("label", _hoisted_6, [
                        _createVNode(_component_icon_sprite, {
                          "ist-klein": true,
                          "css-klassen": "c-form-control-checkbox__icon",
                          "icon-name": "icon-check-mark"
                        }),
                        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, [
                          _createTextVNode("Ja, die "),
                          _createElementVNode("a", {
                            class: "agree-link",
                            href: "https://www.gev-versicherung.de/informationen/datenschutz/",
                            target: "_blank"
                          }, "Datenschutzhinweise"),
                          _createTextVNode(" habe ich zur Kenntnis genommen. ")
                        ], -1))
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.datenschutzhinweiseAkzeptiert
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_Zeile, {
                key: 2,
                class: "c-form-control-checkbox form-group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Zelle, { breite: 12 }, {
                    default: _withCtx(() => [
                      _createElementVNode("input", {
                        id: "datenschutzhinweiseAkzeptiert",
                        onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setzeDatenschutzUndWerbeeinwilligung && _ctx.setzeDatenschutzUndWerbeeinwilligung(...args))),
                        class: "c-form-control-checkbox__input c-form-control-checkbox__input--spring",
                        type: "checkbox",
                        value: true,
                        "aria-label": "Datenschutzhinweise habe ich zur Kenntnis genommen und bin damit einverstanden, dass\n                die GEV meine Angaben im Onlineantrag vorübergehend speichert\n                und mich in diesem Rahmen kontaktiert.",
                        "data-fehlermeldung": "Bitte akzeptieren Sie die Datenschutzhinweise.",
                        name: "datenschutzhinweiseAkzeptiert"
                      }, null, 32),
                      _createElementVNode("label", _hoisted_7, [
                        _createVNode(_component_icon_sprite, {
                          "ist-klein": true,
                          "css-klassen": "c-form-control-checkbox__icon",
                          "icon-name": "icon-check-mark"
                        }),
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, [
                          _createTextVNode("Ja, die "),
                          _createElementVNode("a", {
                            class: "agree-link",
                            href: "https://www.gev-versicherung.de/informationen/datenschutz/",
                            target: "_blank"
                          }, "Datenschutzhinweise"),
                          _createTextVNode(" habe ich zur Kenntnis genommen und bin damit einverstanden, dass die GEV meine Angaben im Onlineantrag vorübergehend speichert und mich in diesem Rahmen kontaktiert. Die Daten werden entweder auf mein Verlangen oder spätestens nach 90 Tagen unwiderruflich gelöscht. ")
                        ], -1))
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })),
          (_ctx.isVorschlagEmail && _ctx.istOutboundAktiv)
            ? (_openBlock(), _createBlock(_component_Zeile, {
                key: 3,
                class: "c-form-control-checkbox form-group"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Zelle, { breite: 12 }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("input", {
                        id: "werbeeinwilligung",
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.werbeeinwilligung) = $event)),
                        class: "c-form-control-checkbox__input c-form-control-checkbox__input--spring",
                        type: "checkbox",
                        value: "true",
                        name: "werbeeinwilligung",
                        "aria-label": "Ja, ch bin damit einverstanden, dass die GEV meine Angaben im Onlineantrag vorübergehend speichert und\n                mich in diesem Rahmen kontaktiert."
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.state.werbeeinwilligung]
                      ]),
                      _createElementVNode("label", _hoisted_8, [
                        _createVNode(_component_icon_sprite, {
                          "ist-klein": true,
                          "css-klassen": "c-form-control-checkbox__icon",
                          "icon-name": "icon-check-mark"
                        }),
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "c-form-control-checkbox__label-text" }, "Ich bin damit einverstanden, dass die GEV meine Angaben im Onlineantrag vorübergehend speichert und mich in diesem Rahmen kontaktiert. Die Daten werden entweder auf mein Verlangen oder spätestens nach 90 Tagen unwiderruflich gelöscht.", -1))
                      ]),
                      _createVNode(_component_validierungs_fehler, {
                        "fehler-text": _ctx.fehler.werbeeinwilligung
                      }, null, 8, ["fehler-text"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Zeile, { style: {"padding-top":"32px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_Zelle, {
                breite: 6,
                class: "u-text-align-left"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    id: "quoteByEmailCancelBtn",
                    class: "c-button c-button--inverted",
                    type: "button",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.closeModal()))
                  }, " Abbrechen ")
                ]),
                _: 1
              }),
              _createVNode(_component_Zelle, {
                breite: 6,
                class: "u-text-align-right"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("button", {
                    id: "quoteByEmailContinueBtn",
                    class: "c-button right",
                    type: "button",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.submitModalData()))
                  }, _toDisplayString(_ctx.isVorschlagEmail === true ? "Per E-Mail anfordern" : "Vorschlag herunterladen"), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_ctx.showError)
      ? (_openBlock(), _createBlock(_component_Fehlermeldung, {
          key: 1,
          onCloseModal: _ctx.closeModal,
          onResetForm: _ctx.resetForm
        }, null, 8, ["onCloseModal", "onResetForm"]))
      : _createCommentVNode("", true),
    (_ctx.showSuccess)
      ? (_openBlock(), _createBlock(_component_EmailBestaetigung, {
          key: 2,
          onCloseModal: _ctx.closeModal
        }, null, 8, ["onCloseModal"]))
      : _createCommentVNode("", true)
  ], 64))
}